import React from 'react';
import classnames from 'classnames';
import { ReactComponent as Logos } from 'assets/svg/reseller-logos.svg?react';
import commonClasses from '../../what-we-offer.scss';
import classes from './brands-we-offer.scss';
export const BrandsWeOffer = () => /*#__PURE__*/React.createElement("div", {
  className: classes.root
}, /*#__PURE__*/React.createElement("div", {
  className: classes.content
}, /*#__PURE__*/React.createElement("div", {
  className: classnames(commonClasses.title, classes.title)
}, "BRANDS WE OFFER"), /*#__PURE__*/React.createElement("div", {
  className: classes.logosWrapper
}, /*#__PURE__*/React.createElement(Logos, {
  className: classnames(classes.weOfferLogos, classes.weOfferLogos0)
}), /*#__PURE__*/React.createElement(Logos, {
  className: classnames(classes.weOfferLogos, classes.weOfferLogos1)
}), /*#__PURE__*/React.createElement(Logos, {
  className: classnames(classes.weOfferLogos, classes.weOfferLogos2)
}))));